import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

interface ResumoCompraValores {
  quantidadeProdutos: number;
  valorTotal: number;
}

export function informarValoresResumoCompra(valores: ResumoCompraValores) {
  return sessionStorage.setItem(
    'chippuPlace@ResumoCompra',
    JSON.stringify(valores),
  );
}

export function removerValoresResumoCompra() {
  return sessionStorage.removeItem('chippuPlace@ResumoCompra');
}

export default function useResumoCompraHook() {
  const router = useRouter();

  const [valoresResumoCompra, setValoresResumoCompra] =
    useState<ResumoCompraValores | null>(null);

  async function recuperarValoresSessionStorage() {
    const valoresResumoCompraSessionStorage = sessionStorage.getItem(
      'chippuPlace@ResumoCompra',
    );

    if (valoresResumoCompraSessionStorage) {
      const valoresResumoCompraConvertido: ResumoCompraValores = JSON.parse(
        valoresResumoCompraSessionStorage,
      );
      setValoresResumoCompra(valoresResumoCompraConvertido);
    }
  }

  useEffect(() => {
    recuperarValoresSessionStorage();
  }, []);

  return { valoresResumoCompra, router };
}
